import script from "./TablePoHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./TablePoHistory.vue?vue&type=script&setup=true&lang=js"

import "./TablePoHistory.vue?vue&type=style&index=0&id=c192bea4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c192bea4"]])

export default __exports__